import { render } from "./HintButton.vue?vue&type=template&id=2a87bf5a&scoped=true&ts=true"
import script from "./HintButton.vue?vue&type=script&lang=ts"
export * from "./HintButton.vue?vue&type=script&lang=ts"

import "./HintButton.vue?vue&type=style&index=0&id=2a87bf5a&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a87bf5a"]])

export default __exports__